import React from "react";
import {
  Card,
  Line,
  Indicator,
  Name,
  Value,
  Units,
} from "./RealtimeCard.styles";

interface CardProps {
  name: string | undefined;
  value?: string | number | undefined;
  units: string | undefined;
  color?: string | undefined;
  hidden?: boolean;
  onClick?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

const RealtimeCard: React.FC<CardProps> = ({
  name,
  value,
  units,
  color,
  hidden,
  onClick,
  onMouseEnter,
  onMouseLeave,
}) => {
  return (
    <Card
      $color={color}
      $hidden={Boolean(hidden)}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      <Line>
        <Indicator $color={color} />
        <Value $color={color}>{value?.toString() ?? "0.0"}</Value>
        <Units $color={color}>{units ?? ""}</Units>
      </Line>
      <Line>
        <Name>{name ?? ""}</Name>
      </Line>
    </Card>
  );
};

export default React.memo(RealtimeCard);
